import angular from "angular";
import NoteTargetSelectionController from "./note_target_selection.controller";
import dialogTemplate from "./note_target_selection.tmpl.html";

export default angular
    .module("sbApp.sbNoteTargetSelectionDialog", [
        "sbApp.directives",
        "ngMaterial",
    ])
    .config(function ($mdDialogProvider) {
        "ngInject";
        $mdDialogProvider.addPreset("noteTargetSelection", {
            methods: ["activities"],
            options: function NoteTargetSelectionDialog() {
                return {
                    templateUrl: dialogTemplate,
                    controller: NoteTargetSelectionController,
                    controllerAs: "dialog",
                    bindToController: true,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: true,
                    hasBackdrop: true,
                };
            },
        });
    });
